import { editTask as editTaskApi } from '@/services/api/workspace-api'
import { useWorkspaceStore } from '@/stores/workspaces'
import type { Task } from '@/types/workspaces'
import { ref } from 'vue'

const tasks = ref<Task[]>([])
const filters = ref<Record<string, unknown>>({})
const loading = ref(false)

export default function useTasks() {
  const workspaceStore = useWorkspaceStore()

  const fetchData = async (needLoading = true) => {
    try {
      if (needLoading) {
        loading.value = true
      }
      const response = await workspaceStore.fetchTasks(filters.value)
      tasks.value = response ?? []
    } catch (error) {
      console.error(error)
    } finally {
      if (needLoading) {
        loading.value = false
      }
    }
  }

  const editTask = async (taskId: string, workspaceId: string, data: Record<string, unknown>) => {
    try {
      const result = await editTaskApi(workspaceId, taskId, data)
      tasks.value = tasks.value.map((task) => (task.id === taskId ? result : task))
    } catch (error) {
      console.error(error)
    }
  }

  return {
    tasks,
    filters,
    loading,
    fetchData,
    editTask,
  }
}
